{
  "pt": {
    "issue_category": {
      "labels": {
        "backup_category": "Categoria de substituição",
        "category_name": "Nome da categoria",
        "delete_category": "Eliminar categoria \"{name}\"?",
        "delete_category_disclaimer": "Todos os itens de pós-venda com esta categoria serão reatribuídos à categoria que selecionar abaixo.",
        "integration_warning": "Está ativa uma integração com o módulo Pós-venda na sua plataforma. Se pretender criar ou editar categorias, contacte-nos.",
        "new_category": "Categoria"
      }
    }
  }
}
